import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { AddEditUserService } from '../../../../../services/add-edit-user.service';
import { Router } from '@angular/router';
import { DataTransferService } from '../../../../../services/DataTransferService';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '../../../../../services/usre.service';
import { LocationService } from '../../../../../services/location.service';
import { TranslateService } from '@ngx-translate/core';



@Component({
  selector: 'user-management-user-settings',
  templateUrl: './user-settings.component.html',
  styleUrls: ['./user-settings.component.scss']
})
export class UserSettingsComponent implements OnInit, OnChanges {

  @Input() updateCommandEx = false;
  @Input('user') user = {} as any;
  @Input() type: number;
  @Output() reload = new EventEmitter();
  cashierEnable: boolean = false;
  outletMgrEnable: boolean = false;
  operationsEnable: boolean = false;
  cashierDefaultSettings: any;
  roles: IRole[] = [];
  locationUser: any;
  network = {} as any;
  branchSettings = JSON.parse(sessionStorage.getItem("branchSettings")) as any[];
  @Input() locationRoles = [] as any[];
  constructor(private userManage: AddEditUserService,
    private router: Router,
    private data: DataTransferService,
    private toaster: ToastrService,
    private userService: UserService,
    private locationService: LocationService,
    private translate: TranslateService) {
    this.locationUser = {} as ILocationUser;

  }
  setRoles() {

    if (this.type == 2 && this.user.Roles != undefined) {
      this.roles = this.user.Roles
      this.cashierEnable = false;
      this.operationsEnable = false;
      this.outletMgrEnable = false;
      this.roles.forEach((role, index) => {

        this.locationRoles.forEach((item, i) => {
          if (item.Type == role.Type && item.Description.includes("Cashier"))
            this.cashierEnable = true;
          else if (item.Type == role.Type && item.Description.includes("Operations"))
            this.operationsEnable = true;
          else if (item.Type == role.Type && item.Description.includes('Outlet'))
            this.outletMgrEnable = true;

        })
        
      })
    }
  }

  onSelectAccounts(accounts) {
    this.locationUser.Accounts = accounts;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.setRoles()
    if (this.updateCommandEx == true) {
      this.save();
    }
  }
  onSelectCashierSettings(event) {
    if (!event.PaymentDeviceEnabled) { 
      event.PaymentDeviceCode = null;
      event.PaymentDeviceTerminal = null;
    }

    this.locationUser.Settings = event != undefined ? event : this.cashierDefaultSettings;

    var currentUser = JSON.parse(sessionStorage.getItem("user"));

    if (this.user.UserId == currentUser.UserId) {
      currentUser.Settings = event;
      sessionStorage.setItem("user", JSON.stringify(currentUser));
    }

  }
  toggleRoles(role) {
    var index = this.roles.findIndex(function (item, i) {
      return item.Type === role.Type;
    });
    if (index > -1)
      this.roles.splice(index, 1)
    else
      this.roles.push(role)
  }
  enableCashierSettings() {
    var index = this.locationRoles.findIndex(item => item.Description.includes("Cashier"));
    var role = this.locationRoles[index]
    this.toggleRoles(role);
    if (this.cashierEnable) {
      this.cashierEnable = false;
    }
    else {
      this.cashierEnable = true;
    }
  }
  enableOutletMgr() {
    var index = this.locationRoles.findIndex(item => item.Description.includes("Outlet"));
    var role = this.locationRoles[index]
    this.toggleRoles(role);
    if (this.outletMgrEnable) {
      this.outletMgrEnable = false;
    }
    else {
      this.outletMgrEnable = true;
    }
  }
  enableOperations() {
    var index = this.locationRoles.findIndex(item => item.Description.includes("Operations"));
    var role = this.locationRoles[index]
    this.toggleRoles(role);
    if (this.operationsEnable) {
      this.operationsEnable = false;
    }
    else {
      this.operationsEnable = true;
    }
  }
  currentLocationId: any;

  save() {
    if (this.roles.length != 0) {
      var outboundEnabled = this.branchSettings.find(i => i.Key == 2).Value;
      var hasCashierRole = this.roles.filter(x => x.Type == 1).length > 0;
      if (hasCashierRole && this.locationUser.Accounts.length == 0 && outboundEnabled == true) {
        this.toaster.warning(`${this.translate.instant('pages.userModification.userSettings.minAccountWarning')}`);
        return false;
      }
      else {
        if (this.currentLocationId == undefined && sessionStorage.getItem("company") != undefined) {
          this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
        }
        this.network = JSON.parse(sessionStorage.getItem('user')).Network
        this.locationUser.Roles = this.roles;
        this.locationUser.UserId = this.user == "{}" ? 0 : this.user.UserId;
        this.locationUser.UserName = this.user.EmailAddress;
        this.locationUser.FirstName = this.user.FirstName;
        this.locationUser.LastName = this.user.LastName;
        this.locationUser.EmailAddress = this.user.EmailAddress;
        this.locationUser.DisplayName = this.user.DisplayName;
        this.locationUser.UserLocationId = this.user.UserLocationId;
        this.locationUser.Active = true;
        this.locationUser.Roles = this.roles;
        this.locationUser.Network = this.network;
        if (this.user.Settings) {
          this.locationUser.Settings = this.user.Settings;
        }
        else {
          this.userManage.getDefaultSettings((res) => {
            this.locationUser.Settings = res;
          }, (err) => { })
        }
        if (this.locationUser.UserId == 0) {
          this.userManage.addUser(this.locationUser,
            (res) => {
              this.router.navigate(["/dashboard/outlet-manager/user-management"]);
            },
            (err) => { });
        }
        else {
          this.userManage.updateUser(this.locationUser.UserLocationId, this.locationUser, (res) => {
            this.router.navigate(["/dashboard/outlet-manager/user-management"]);
            this.reload.emit(true)
          },
            (err) => { });
        }
        this.updateCommandEx = false;
      }
    }
    else {
      this.deactivateUser(this.user.UserLocationId);
    }
  }

  deactivateUser(userId) {
    this.userService.deactivateUser(userId, (res) => {
    }, (err) => { })
  }

  ngOnInit() {
    this.locationService.getLocationRoles((res) => {
      this.locationRoles = res;
  
    }, (err) => { })
    this.locationUser.Accounts = this.user.Accounts

  }
}
